<div class="select-container" [id]="UniqueId">
  <div class="custom-select" [class.open-dropdown]="OpenDropdown" [class.error]="Error" (click)="toggleDropdown()">
    <div style="width: 100%;">
      <div class="placeholder-top">
        {{Placeholder}}
      </div>

      <div class="span-ellipsis" *ngIf="!Loading">
        <ng-container *ngIf="selectedItems.length > 0; else noSelection">
          <div style="display: flex; flex-wrap: nowrap; gap: 3px">
            <span *ngFor="let item of selectedItems; let first = first; let last = last">
              {{ TranslateKey ? (TranslateKey + item[KeyName[0]] | translate) : item[KeyName[0]] }}{{!last &&
              (selectedItems.length > 1) ? ', ':
              ''}}
            </span>
          </div>
          <!-- <div *ngIf="primitiveMode" style="display: flex; flex-wrap: nowrap; gap: 3px">
            <span *ngFor="let item of selectedItems; let first = first; let last = last">
              {{ TranslateKey ? (TranslateKey + item | translate) : item }}{{!last && (selectedItems.length > 1) ? ', ':
              ''}}
            </span>
          </div> -->
        </ng-container>

        <ng-template #noSelection>
          <span>Todos</span>
        </ng-template>
      </div>

      <div class="span-ellipsis" *ngIf="Loading">
        <span class="placeholder-select">
          {{ 'Loading' | translate }}
        </span>
      </div>
    </div>

    <div class="chevron" [class.open]="OpenDropdown"></div>
  </div>

  <div class="options-container" [ngClass]="{'absolute': ShowAbsolute}" [style.width]="dropdownWidth"
    *ngIf="OpenDropdown">
    <div class="options-scroll">

      <div *ngFor="let option of DataArray; let last = last">
        <div (click)="selectOption(option)" [ngClass]="isSelected(option) ? 'selected-option' : 'option'"
          [attr.aria-selected]="isSelected(option)">
          <input class="checkbox-square" type="checkbox" [checked]="isSelected(option)" />

          <p>
            {{ TranslateKey ? (TranslateKey + option[KeyName[0]] | translate) : option[KeyName[0]] }}
          </p>
        </div>

        <div class="split-option" *ngIf="!last"></div>
      </div>

    </div>
  </div>
</div>